import axios from 'axios';

var Share = function() {

  let _lang;

  function getShare(share_type, score) {
    console.log(`getShare ${share_type}, score ${score}`);
    const _text = _lang[share_type].replace(/\[XX\]/, score);
    console.log(`getShare TEXT`, _text);
    return _text;
  }

  function initShare() {
    axios.get('lang/share.json?'+Math.floor(Math.random() * 10000))
      .then((response)=>{
        console.log(`JSON SHARE loaded`);
        _lang = response.data[window.lang]
        if (_lang) {
          _lang = _lang.share
          console.log(`Share`, _lang);
        } else {
          _lang = response.data['en']
          console.log(`Share ${window.lang} doesn't exist, switch to english`);
        }
      })
      .catch((error)=>{
        console.error(`Error loading json`, error)
      })
  }

  return {
    initShare,
    getShare
  }
}

export {Share as default}
